import React from 'react';

import Button from '../../../components/ui/Button';

const FilterChip = ({ label, count, onRemove, isActive = true }) => {
  return (
    <div className={`
      inline-flex items-center space-x-2 px-3 py-1.5 rounded-pill text-sm transition-smooth
      ${isActive 
        ? 'bg-primary text-primary-foreground' 
        : 'bg-background text-text-secondary border border-border'
      }
    `}>
      <span className="font-body-semibold">{label}</span>
      {count && (
        <span className="font-data font-data-medium text-xs">({count})</span>
      )}
      {onRemove && (
        <Button
          variant="ghost"
          onClick={onRemove}
          className="p-0.5 hover:bg-white hover:bg-opacity-20 rounded-full"
          iconName="X"
          iconSize={14}
        />
      )}
    </div>
  );
};

export default FilterChip;